/**
 * Legacy session key for the old FE-owned Agent picks countdown.
 * Next refresh is now derived from API `completedAt + 1h` (see FeedPage).
 * Kept so logout can clear any leftover key from older sessions.
 */
export const RECO_COUNTDOWN_ANCHOR_STORAGE_KEY = 'agentPicksCountdownAnchor';

export function clearRecoCountdownAnchor(): void {
  try {
    sessionStorage.removeItem(RECO_COUNTDOWN_ANCHOR_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
